import type { Bounds } from '../types';

interface EntityWithBounds {
    getBounds(): Bounds;
}

export class CollisionDetector {
    static checkCircleCollision(entity1: Bounds, entity2: Bounds): boolean {
        const dx = entity1.x - entity2.x;
        const dy = entity1.y - entity2.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        const minDistance = entity1.radius + entity2.radius;

        return distance < minDistance;
    }

    static checkPlayerBulletCollisions<T extends EntityWithBounds>(
        player: EntityWithBounds,
        bullets: T[]
    ): boolean {
        const playerBounds = player.getBounds();

        for (let i = bullets.length - 1; i >= 0; i--) {
            const bullet = bullets[i];
            if (!bullet) continue;
            const bulletBounds = bullet.getBounds();

            if (this.checkCircleCollision(playerBounds, bulletBounds)) {
                // 충돌한 총알 제거
                bullets.splice(i, 1);
                return true;
            }
        }

        return false;
    }

    static checkPlayerItemCollisions<T extends EntityWithBounds>(
        player: EntityWithBounds,
        items: T[]
    ): T[] {
        const playerBounds = player.getBounds();
        const collectedItems: T[] = [];

        for (const item of items) {
            const itemBounds = item.getBounds();

            if (this.checkCircleCollision(playerBounds, itemBounds)) {
                collectedItems.push(item);
            }
        }

        return collectedItems;
    }
}
